import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Questions } from 'src/app/common-class/questions';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';

@Component({
  selector: 'app-descriptive-text',
  templateUrl: './descriptive-text.component.html',
  styleUrls: ['./descriptive-text.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class DescriptiveTextComponent implements OnInit,OnChanges {

  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() isMobile: boolean;
  @Input() isNewParticipationButton: boolean;
  @Input() isDarkTheme: boolean;

  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();
  @Output() ChangeLoadingAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();
  questions: Questions;
  isRTL: boolean;
  isNewParticipation: boolean;
  surveyFormat: number;
  newParticipationBtnText: string;
  theme: string;
  isqtitlelarge: boolean;
  isAnsChange: boolean = false;

  constructor(private service:ParticipationDataService) { }

  ngOnInit() {  
    if (this.questions == null) {
      this.questions = JSON.parse(this.JsonData);
       if (this.questions.qsubtype == 1) {
         this.questions.AnswerText = null;
         //this.ChangeAnswersData.emit(this.questions);
         this.ChangeLoadingAnswersData.emit(this.questions);
         this.isAnsChange = false;
       }
    }

    if(this.isDarkTheme) {
      this.theme="dark"
    } else {
      this.theme="light"
    }

    this.isRTL = this.service.getRTL()
    this.isNewParticipation = this.service.isNewParticipation;
    this.surveyFormat = this.service.surveyFormat;
    this.newParticipationBtnText = this.service.newParticipationBtnText;
    if ((this.questions.qtitle.length > 50 || (this.questions.qtitle.match(/<br \/>/g) || []).length > 1) && this.surveyFormat == 2) {
      this.isqtitlelarge = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.isDarkTheme!=undefined &&  changes.isDarkTheme.currentValue != changes.isDarkTheme.previousValue) {
      if (this.isDarkTheme) {
        this.theme = "dark"
      } else {
        this.theme = "light"
      }
    }
  }

  resolved(captchaResponse: string) {
    if (captchaResponse != null || captchaResponse != "") {
      this.questions.AnswerText = "Captcha Success";
      this.ChangeAnswersData.emit(this.questions);
      this.isAnsChange = true;
    }
  }

  gotoNextQuestion(question: Questions, event) {
    this.service.gotoNextQuestion(question, event) ;
  }

  gotoNextQuestionKeyboard(question,event) {
    event.preventDefault();
    this.gotoNextQuestion(question,event.target);
  }
}
